// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"314":"56eb193a","448":"43ef534a"}[chunkId] + ".chunk.css";
};